import React, { useState, useEffect, useRef, useCallback } from 'react';
import '../styles/game.css';
const BOARD_SIZE = 20;
const INITIAL_POSITION = [{ x: 5, y: 5 }];
const DIRECTIONS = {
  ArrowUp: { x: 0, y: -1 },
  ArrowDown: { x: 0, y: 1 },
  ArrowLeft: { x: -1, y: 0 },
  ArrowRight: { x: 1, y: 0 },
  w: { x: 0, y: -1 },
  s: { x: 0, y: 1 },
  a: { x: -1, y: 0 },
  d: { x: 1, y: 0 },
};

export default function Game() {
  const [snake, setSnake] = useState(INITIAL_POSITION);
  const [direction, setDirection] = useState(DIRECTIONS.ArrowRight);
  const [food, setFood] = useState(generateFood());
  const [score, setScore] = useState(0);
  const [isRunning, setIsRunning] = useState(false);
  const intervalRef = useRef(null);

  function generateFood() {
    return {
      x: Math.floor(Math.random() * BOARD_SIZE),
      y: Math.floor(Math.random() * BOARD_SIZE),
    };
  }

  const resetGame = useCallback(() => {
    setSnake(INITIAL_POSITION);
    setDirection(DIRECTIONS.ArrowRight);
    setFood(generateFood());
    setScore(0);
    setIsRunning(false);
  }, []);

  useEffect(() => {
    function handleKeyDown(e) {
      if (DIRECTIONS[e.key]) {
        setDirection(DIRECTIONS[e.key]);
      }
    }
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  useEffect(() => {
    if (!isRunning) return;

    intervalRef.current = setInterval(() => {
      setSnake((prev) => {
        const head = { ...prev[0] };
        const newHead = {
          x: head.x + direction.x,
          y: head.y + direction.y,
        };

        if (
          newHead.x < 0 ||
          newHead.y < 0 ||
          newHead.x >= BOARD_SIZE ||
          newHead.y >= BOARD_SIZE
        ) {
          alert('Game Over!');
          resetGame();
          return INITIAL_POSITION;
        }

        let newSnake = [newHead, ...prev];

        if (newHead.x === food.x && newHead.y === food.y) {
          setScore(score + 50);
          setFood(generateFood());
        } else {
          newSnake.pop();
        }

        return newSnake;
      });
    }, 300);

    return () => clearInterval(intervalRef.current);
  }, [direction, food, score, resetGame, isRunning]);

  return (
    <div className="snake-game">
      <h1>Snake Game</h1>
      <div className="info">
        <span>Your Score: {score}</span>
        <button onClick={resetGame}>Restart Game</button>
        {!isRunning && <button onClick={() => setIsRunning(true)}>Start Game</button>}
      </div>
      <div className="board">
        {[...Array(BOARD_SIZE)].map((_, y) => (
          <div key={y} className="row">
            {[...Array(BOARD_SIZE)].map((_, x) => {
              const isSnake = snake.some(seg => seg.x === x && seg.y === y);
              const isFood = food.x === x && food.y === y;
              return (
                <div
                  key={x}
                  className={`cell ${isSnake ? 'snake' : ''} ${isFood ? 'food' : ''}`}
                />
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
}
